import type { PropsWithChildren } from "react";
import { Toaster } from "sonner";
import { Header } from "@/components/layout/Header";
import { FlashcardsModal } from "@/components/flashcards/FlashcardsModal";
import { useRememberCourseDashboard } from "@/hooks/useRememberCourseDashboard";
import { useTokenRefresh } from "@/hooks/useTokenRefresh";

export const AppLayout = ({ children }: PropsWithChildren) => {
  useTokenRefresh();
  useRememberCourseDashboard();
  return (
    <div className="flex h-screen flex-col overflow-hidden text-foreground">
      <Header />
      <main className="flex-1 overflow-y-auto overflow-x-hidden">
        {children}
      </main>
      <Toaster position="top-center" richColors />
      <FlashcardsModal />
    </div>
  );
};
